import React from 'react';
import { makeStyles, Card, CardHeader, Typography } from '@material-ui/core';

import { Table, TableColumn, Spacing } from 'components';
import { COLORS } from 'constants/styles';
import useShows from 'hooks/useShows';
import useSubscription from 'hooks/useSubscription';
import { ShowDb } from 'types';

import SubscriptionActionCards from './SubscriptionActionCards';

const useStyles = makeStyles({
  card: {
    paddingBottom: '0',
  },
});

const SubscriptionTable: React.SFC = () => {
  const classes = useStyles();
  const { shows } = useShows();
  const { price } = useSubscription();
  const { unitAmount } = price || { unitAmount: 1 }; // Note: this is ugly :( make better
  const unitPriceDollars = unitAmount / 100; // TODO: prob put this in the provider

  // TODO: pull price from show
  const showRows = shows.map((show: ShowDb) => ({
    show: { value: show.title },
    price: { value: `$${unitPriceDollars}` },
  }));

  const totalsRow = {
    show: { value: 'Total', bold: true },
    price: { value: `$${shows.length * unitPriceDollars}`, bold: true },
  };

  const rows = [...showRows, totalsRow];

  const renderer = (row: any) => {
    const c = row.bold ? COLORS.BLACK_87 : COLORS.BLACK_6;
    const fw = row.bold ? 'bold' : 'normal';
    return (
      <Typography variant="body1" style={{ color: c, fontWeight: fw }}>
        {row.value}
      </Typography>
    );
  };

  const columns: TableColumn[] = [
    { id: 'show', label: 'Active Shows', renderer },
    { id: 'price', label: 'Price', align: 'right', renderer },
  ];

  return (
    <Card className={classes.card}>
      <CardHeader title="Subscription" />
      <SubscriptionActionCards />
      <Spacing height="8px" />
      <Table columns={columns} rows={rows} />
    </Card>
  );
};

export default SubscriptionTable;
